<script setup>
import AdvancedDatabaseTypeManager from '@/views/apps/databaseType/list/AdvancedDatabaseTypeManager.vue'

definePage({
  meta: {
    action: 'read',
    subject: 'databaseTypes',
  },
})
</script>

<template>
  <section>
    <AdvancedDatabaseTypeManager></AdvancedDatabaseTypeManager>
  </section>
</template>
